import React, { Component } from 'react';
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import PdfRender from "./PdfRender";
import {handleDownloadClick} from "../../utils/Download";
import {storageUrl} from "../../utils/storageUrl";
import axios from "../../config/axios";
import Loading from "./Loading";
import { trackEvent, AnalyticsEvents } from "../../utils/analytics";

// Dernier CV livré avec le build du front (public/storage), servi par le
// domaine du front. Utilisé seulement si l'API ne renvoie pas de CV actif.
const FALLBACK_CV = "/storage/Curriculum_Vitae_-_Ahmed_Karim.v5_1.pdf";

export default class CurriculumVitae extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cv: null,
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.loadActiveCV();
    }

    loadActiveCV = async () => {
        try {
            const response = await axios.get("/api/cvs/active");
            
            if (response.data.success && response.data.cv) {
                // Le PDF est servi par l'API, pas par le domaine du front
                const { cv } = response.data;
                this.setState({
                    cv: {
                        ...cv,
                        filepath: cv.url || storageUrl(cv.filepath)
                    },
                    loading: false
                });
            } else {
                // Aucun CV actif trouvé, utiliser le CV par défaut en fallback
                this.setState({
                    cv: { filepath: FALLBACK_CV },
                    loading: false
                });
            }
        } catch (error) {
            console.error("Error loading active CV:", error);
            // En cas d'erreur, utiliser le CV par défaut en fallback
            this.setState({
                cv: { filepath: FALLBACK_CV },
                loading: false,
                error: "Impossible de charger le CV actif"
            });
        }
    }

    render() {
        const { cv, loading, error } = this.state;

        if (loading) {
            return (
                <section className="work-area section-gap-top" id="cv">
                    <div className="container">
                        <div className="row d-flex justify-content-center">
                            <Loading />
                        </div>
                    </div>
                </section>
            );
        }

        if (!cv) {
            return (
                <section className="work-area section-gap-top" id="cv">
                    <div className="container">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-12">
                                <div className="section-title">
                                    <h2>Curriculum Vitae</h2>
                                    <p className="mw-100 text-center">Aucun CV disponible pour le moment.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <>
                {/* Start Work Area Area */}
                <section className="work-area section-gap-top" id="cv">
                    <div className="container">
                        <div className="row d-flex justify-content-between align-items-end">
                            <div className="col-lg-12 mb-3">
                                <div className="section-title">
                                    <h2>Curriculum Vitae</h2>
                                    <p className="mw-100 text-center">Voici mon CV. Vous pouvez le telecharger en regardant ci-dessous...</p>
                                </div>
                            </div>

                            <div className="col-lg-12 d-flex flex-column justify-content-center">
                                <div className="wrapper-pdf">
                                    <PdfRender file={cv.filepath} download={false} />
                                </div>
                                <div className="mt-3 d-flex justify-content-center">
                                    <button className="primary-btn" data-text="Telecharger" onClick={(e) => { trackEvent(AnalyticsEvents.CV_DOWNLOAD, { filename: cv.filename || null }); handleDownloadClick(e, cv.filepath, cv.filename); }}>
                                        { "Telecharger".split("").map((rows, keys) => <span key={ keys }>{ rows }</span>) }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Work Area Area */}
            </>
        );
    }
}